import api from "@/services/api";

export const state = {
  procedures: [],
  procedure: {},
};

export const mutations = {
  INIT_ASSOCIATION_PROCEDURES(state, payload) {
    state.procedures = payload;
  },
  INIT_ASSOCIATION_PROCEDURE(state, payload) {
    state.procedure = payload;
  },
};

export const actions = {
  getAssociationProcedures({ commit }, payload) {
    return api.getAssociationProcedures(payload).then((response) => {
      commit("INIT_ASSOCIATION_PROCEDURES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getAssociationProcedureById({ commit }, payload) {
    return api.getAssociationProcedureById(payload).then((response) => {
      commit("INIT_ASSOCIATION_PROCEDURE", response.data.data);
    });
  },
};

export const getters = {
  getAssociationProcedures: (state) => state.procedures,
  getAssociationProcedure: (state) => state.procedure,
};
